import { Redirect, Route, Switch } from 'react-router';
import { ROUTE_PATH } from './route-paths';
import AdminRedirectPage from '../containers/redirect-pages/admin-redirect-page';

export const AdminRouter = () => {
  return (
    <Switch>
      <Route exact path={ROUTE_PATH.ADMIN_REDIRECT} component={AdminRedirectPage} />
      <Route path="*" render={() => <Redirect to={ROUTE_PATH.ADMIN_REDIRECT} />} />
    </Switch>
  );
};
